/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import announcementSvg from '../../../../public/announcements-ico.svg';
class MissionAnnouncements extends React.Component {

  render() {

    return (
      <div className="container pt-2">
        {/* <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Announcements</li>
          </ol>
        </nav> */}
        <div className="row bg-light p-2 mt-5 mb-3 rounded rounded-2 m-ver-col">
          <div className="col-md-10 head-title">
            <h4 >Announcements, <span className="linear-title">Ayush Australia</span></h4>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus
            </p>
          </div>
          <div className="col-md-2 d-flex align-items-center justify-content-center m-btn">
            <a href="/create-Announcements" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn">
              {/* <i className="fa fa-plus-circle" aria-hidden="true"></i>  */}
              Create New
            </a>
          </div>
          <hr></hr>
          <div className="col-12">
            <div className="row contrast-ration-sol">
              <span className="text-dark d-block mb-2">
                <i className="fa fa-filter" aria-hidden="true" /> Filter Announcements
              </span>
              <div className="col-4 m-filter-col">
                <div className="form-group mb-4 position-relative has-search">
                  <span className="fa fa-search form-search"></span>
                  <input aria-labelledby="searchevent" id="searchevent" type="text" className="form-control pd-tb-675em" name="eventname" placeholder="Search By Event Name" />
                </div>
              </div>
              <div className="col-4 m-filter-col">
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="eventname" id="eventdate" className="form-label over-label2">Date of Event</label>
                  <input aria-labelledby="eventdate" type="text" className="form-control pd-tb-675em" name="eventdate" placeholder="mm/dd/yyyy" />
                </div>
              </div>
              <div className="col-4 m-filter-col">
                <div className="form-group mb-4 position-relative">
                  <select className="form-select pd-tb-675em" aria-labelledby="searchdomain" id="searchdomain">
                    <option value="" selected disabled>Search By Domain</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row bg-light p-2 mt-5 mb-3 rounded rounded-2 m-ver-col">
          <div className="col-12">
            <ul className="nav nav-tabs alleventtabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" id="all-announcements-tab" data-bs-toggle="tab" data-bs-target="#all-announcements-pane" type="button" role="tab" aria-controls="all-announcements-pane" aria-selected="true">All</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="events-awaiting-tab" data-bs-toggle="tab" data-bs-target="#events-awaiting-pane" type="button" role="tab" aria-controls="events-awaiting-pane" aria-selected="false">New Announcements</button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="all-announcements-pane" role="tabpanel" aria-labelledby="all-announcements-pane">
                <div className="row mt-4 eve-card">
                  <div className="col-12 mb-4">
                    <div className="fw-normal show-count">Showing 8 of 10 results...</div>
                  </div>
                  <div className="col-12 mb-3 m-ancmtcard">
                    <div className="card p-2 rounded rounded-4">
                      <div className="row">
                        <div className="col-1 text-end ancmtimg">
                          <img src={announcementSvg} className="mt-3" alt="announcement" />
                        </div>
                        <div className="col-11">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold">Name of the Mission wide announcement <span className="badge bg-secondary">New</span>
                              <span className="badge bg-success-subtle text-dark float-end fw-normal p-3 px-4 rounded rounded-5">5 Views</span></h5>
                            <div className="domains mt-3">
                              <span className="text-muted dtit">Domians</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Ayurveda</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Homeopathy</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Siddha</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Unani</span>
                            </div>
                            <p className="card-text mt-3 m-ancmnt-dec">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p className="card-text">
                              <a href="/view-announcements" className="card-link fw-bold">View/ Edit Details</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-3 m-ancmtcard">
                    <div className="card p-2 rounded rounded-4">
                      <div className="row">
                      <div className="col-1 text-end ancmtimg">
                          <img src={announcementSvg} className="mt-3" alt="announcement" />
                        </div>
                        <div className="col-11">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold">Name of the Mission wide announcement <span className="badge bg-secondary">New</span>
                              <span className="badge bg-success-subtle text-dark float-end fw-normal p-3 px-4 rounded rounded-5">5 Views</span></h5>
                            <div className="domains mt-3">
                              <span className="text-muted dtit">Domians</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Ayurveda</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Homeopathy</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Siddha</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Unani</span>
                            </div>
                            <p className="card-text mt-3 m-ancmnt-dec">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p className="card-text">
                              <a href="#" className="card-link fw-bold">View/ Edit Details</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-3 m-ancmtcard">
                    <div className="card p-2 rounded rounded-4">
                      <div className="row">
                      <div className="col-1 text-end ancmtimg">
                          <img src={announcementSvg} className="mt-3" alt="announcement" />
                        </div>
                        <div className="col-11">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold">Name of the Mission wide announcement
                              <span className="badge bg-success-subtle text-dark float-end fw-normal p-3 px-4 rounded rounded-5">15 Views</span></h5>
                            <div className="domains mt-3">
                              <span className="text-muted dtit">Domians</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Ayurveda</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Homeopathy</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Siddha</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Unani</span>
                            </div>
                            <p className="card-text mt-3 m-ancmnt-dec">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p className="card-text">
                              <a href="#" className="card-link fw-bold">View/ Edit Details</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-3 m-ancmtcard">
                    <div className="card p-2 rounded rounded-4">
                      <div className="row">
                       <div className="col-1 text-end ancmtimg">
                          <img src={announcementSvg} className="mt-3" alt="announcement" />
                        </div>
                        <div className="col-11">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold">Name of the Mission wide announcement
                              <span className="badge bg-success-subtle text-dark float-end fw-normal p-3 px-4 rounded rounded-5">15 Views</span></h5>
                            <div className="domains mt-3">
                               <span className="text-muted dtit">Domians</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Ayurveda</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Homeopathy</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Siddha</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Unani</span>
                            </div>
                            <p className="card-text mt-3 m-ancmnt-dec">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p className="card-text">
                              <a href="#" className="card-link fw-bold">View/ Edit Details</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade" id="events-awaiting-pane" role="tabpanel" aria-labelledby="events-awaiting-pane" >
                <div className="row mt-4 eve-card">
                  <div className="col-12 mb-4">
                    <div className="fw-normal show-count">Showing 8 of 10 results...</div>
                  </div>
                  <div className="col-12 mb-3 m-ancmtcard">
                    <div className="card p-2 rounded rounded-4">
                      <div className="row">
                       <div className="col-1 text-end ancmtimg">
                          <img src={announcementSvg} className="mt-3" alt="announcement" />
                        </div>
                        <div className="col-11">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold">Name of the Mission wide announcement <span className="badge bg-secondary">New</span>
                              <span className="badge bg-success-subtle text-dark float-end fw-normal p-3 px-4 rounded rounded-5">5 Views</span></h5>
                            <div className="domains mt-3">
                               <span className="text-muted dtit">Domians</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Ayurveda</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Homeopathy</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Siddha</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Unani</span>
                            </div>
                            <p className="card-text mt-3 m-ancmnt-dec">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p className="card-text">
                              <a href="#" className="card-link fw-bold">View/ Edit Details</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-3 m-ancmtcard">
                    <div className="card p-2 rounded rounded-4">
                      <div className="row">
                       <div className="col-1 text-end ancmtimg">
                          <img src={announcementSvg} className="mt-3" alt="announcement" />
                        </div>
                        <div className="col-11">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold">Name of the Mission wide announcement <span className="badge bg-secondary">New</span>
                              <span className="badge bg-success-subtle text-dark float-end fw-normal p-3 px-4 rounded rounded-5">5 Views</span></h5>
                            <div className="domains mt-3">
                               <span className="text-muted dtit">Domians</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Ayurveda</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Homeopathy</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Siddha</span>
                              <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Unani</span>
                            </div>
                            <p className="card-text mt-3 m-ancmnt-dec">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p className="card-text">
                              <a href="#" className="card-link fw-bold">View/ Edit Details</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default MissionAnnouncements;